import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "d-flex flex-column justify-between gap-2 fw-light w-100" }
const _hoisted_2 = { class: "card-header w-100" }
const _hoisted_3 = {
  key: 0,
  class: "upload-area"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "mb-20" }, " Federal law provides that a spouse, if applicable, is entitled to all retirement (Pension and/or Annuity) benefits upon your retirement or death. They will automatically be your beneficiary unless the Fund(s) receive a waiver of such entitlement by your spouse. ", -1)
const _hoisted_5 = { class: "radio-wrapper" }
const _hoisted_6 = {
  key: 0,
  class: "upload-area mt-4"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "text-wrapper w-100" }, [
  /*#__PURE__*/_createElementVNode("h4", null, " Upload Document "),
  /*#__PURE__*/_createElementVNode("p", null, "Upload documentation evidencing your beneficiary's identity as well as the spouse consent / waiver of primary coverage form here.")
], -1)
const _hoisted_8 = { class: "d-flex flex-column gap-10 w-50" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AlertsComponent = _resolveComponent("AlertsComponent")!
  const _component_SelectComponent = _resolveComponent("SelectComponent")!
  const _component_DragDrop = _resolveComponent("DragDrop")!
  const _component_RangeSlider = _resolveComponent("RangeSlider")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_AlertsComponent, { error: _ctx.error }, null, 8, ["error"]),
    _createElementVNode("div", {
      class: _normalizeClass(["card", { 'active': _ctx.isVisible }])
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("h2", null, _toDisplayString(_ctx.title), 1),
          _createElementVNode("a", {
            href: "#",
            class: _normalizeClass(["btn btn-secondary card-toggle-control", { 'hidden': _ctx.isVisible }]),
            onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.toggleCardContent(true)), ["prevent"]))
          }, _toDisplayString(_ctx.savedAllocationBtn), 3),
          _createElementVNode("i", {
            class: _normalizeClass(["iatse-icon-arrow-down card-toggle-control", { hidden: !_ctx.isVisible }]),
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.toggleCardContent(false)))
          }, null, 2)
        ]),
        (_ctx.uploadSection && _ctx.isVisible)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _hoisted_4,
              _createElementVNode("p", null, [
                _createTextVNode("If you are married and would like to name someone other than your spouse, you must obtain a waiver from your spouse and upload it with your submission. "),
                _createElementVNode("a", {
                  class: "fw-normal",
                  onClick: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["prevent"])),
                  href: ""
                }, "Click here to access the waver.")
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _createVNode(_Transition, { name: "slide-fade" }, {
        default: _withCtx(() => [
          (_ctx.isVisible)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: _normalizeClass(["card-content card-toggle pt-0", { 'active': _ctx.isVisible }])
              }, [
                _createElementVNode("div", _hoisted_5, [
                  (_ctx.uploadSection)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                        _hoisted_7,
                        _createElementVNode("div", _hoisted_8, [
                          _createVNode(_component_SelectComponent, {
                            label: "Document Type",
                            selectedOption: _ctx.selectedDocType,
                            "onUpdate:selectedOption": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.selectedDocType) = $event)),
                            options: _ctx.documentTypes,
                            "custom-class": "full-width"
                          }, null, 8, ["selectedOption", "options"]),
                          _createVNode(_component_DragDrop, {
                            customClasses: "grey small",
                            text: "Upload a scanned copy",
                            onChange: _ctx.handleFileSelection,
                            key: "drag-drop-bene-waiver"
                          }, null, 8, ["onChange"])
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createVNode(_component_RangeSlider, {
                  label: "Assign Fund Percentage",
                  sliders: _ctx.sliders,
                  title: _ctx.title,
                  "delete-button": true,
                  onUpdate: _ctx.handleAssignments,
                  onEdit: _cache[4] || (_cache[4] = () => _ctx.sliderEdited = true)
                }, null, 8, ["sliders", "title", "onUpdate"])
              ], 2))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ], 2)
  ], 64))
}